import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type Ruta = components['schemas']['RutaRead']
export type Etapa = components['schemas']['EtapaRead']
export type EtapaEstado = components['schemas']['EtapaEstado']

/** La barra lateral reutiliza esta clave para su punto ámbar (`espera_al_usuario`). */
export function useRuta(businessId: string | undefined) {
  return useQuery({
    queryKey: ['ruta', businessId],
    queryFn: async () => (await api.get<Ruta>(`/businesses/${businessId}/sgsst/ruta`)).data,
    enabled: !!businessId,
  })
}
